import { RevampCategoryPills } from './RevampCategoryPills';
import { RevampPublishDateLine } from './RevampPublishDate';
import type { RevampHeaderCategory } from '../type';

interface RevampHeaderProps {
    label?: string;
    title: string;
    categories: RevampHeaderCategory[];
    professionalName?: string;
    publishDate?: string;
}

/** Article revamp header: byline label, serif headline and category pills. */
export const RevampHeader = ({
    label,
    title,
    categories,
    professionalName,
    publishDate,
}: RevampHeaderProps) => {
    return (
        <header className="mx-auto flex w-full flex-col items-center gap-8 px-4.5 md:w-[75.5rem] md:gap-[2.75rem] md:px-0">
            {/* Headline first in the DOM — it is the reading order mobile
                shows and the one assistive tech should follow. Desktop puts
                the "Sponsored by" line above the headline instead, which is a
                presentation flip rather than a different document. */}
            <div className="flex w-full flex-col items-center gap-3 md:flex-col-reverse">
                <h1 className="m-0 w-full text-center font-gestura text-[2.25rem] leading-none font-normal text-black md:text-[4rem]">
                    {title}
                </h1>
                {/* The design's #9a9a9a only reaches 2.8:1 on white; #767676 is
                    the darkest grey that still reads as a muted byline at the
                    4.5:1 body-text threshold (WCAG AA). */}
                <div className="flex items-center justify-center gap-4 text-center font-sans text-sm font-medium tracking-[-0.05em] text-[#767676] md:text-[0.9375rem] md:leading-[1.22]">
                    {/* On desktop the byline lives in the author rail (Figma
                        2471:69011); keep it here for the mobile flow only. */}
                    {label && <p className="m-0 md:hidden">{label}</p>}
                    {professionalName && (
                        <p className="m-0">Sponsored by {professionalName}</p>
                    )}
                    <RevampPublishDateLine publishDate={publishDate} />
                </div>
            </div>
            <RevampCategoryPills
                categories={categories}
                className="justify-center md:max-w-[37rem]"
            />
        </header>
    );
};
